export const kAxisTickLength = 4
export const kAxisGap = 2
export const kDefaultFontHeight = 12
